import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map, switchMap } from 'rxjs/operators';
import { Observable, combineLatest, of } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { environment } from 'src/environments/environment';
import { FunctionsService } from './functions.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  
  constructor(
    private afs: AngularFirestore,
    private functionsService: FunctionsService  ) {}

  get(chatId) {
    return this.afs
      .collection<any>(`${environment.firebaseConfig.path}`)
      .doc(chatId)
      .snapshotChanges()
      .pipe(
        map(doc => {
          return { id: doc.payload.id, ...doc.payload.data() as {}};
        })
      );
  }



  joinUsers(chat$: Observable<any>) {
    let chat;
    const joinKeys = {};
  
    return chat$.pipe(
      switchMap(c => {
        // Unique User IDs
        chat = c;
        const uids = Array.from(new Set(c.messages.map(v => v.uid)));
  
        // Firestore User Doc Reads
        const userDocs = uids.map(u =>
          this.afs.doc(`users/${u}`).valueChanges()
        );
  
        return userDocs.length ? combineLatest(userDocs) : of([]);
      }),
      map(arr => {
        arr.forEach(v => (joinKeys[(<any>v).uid] = v));
        chat.messages = chat.messages.map(v => {
          return { ...v, user: joinKeys[v.uid] };
        });
  
        return chat;
      })
    );
  }

  sendMessage(message: string, correspondentUserId: string, correspondentSenderName: string, conversationId: string, createConversation: boolean, contentType: number): void {
        let currentUserID = localStorage.getItem('userId');

        let conversations = this.afs.collection(`${environment.firebaseConfig.path}`);
        if (createConversation) {
          conversations.doc(conversationId).set({
            id: conversationId,
            timestamp: this.getUnixEpochInSeconds(),
            senderId: currentUserID,
            senderName: correspondentSenderName,
            target: correspondentUserId
          }).then(() => {
            return this.addMessage(currentUserID, correspondentSenderName, conversationId, message, contentType);
          }).catch(err => console.error(err));
        } else {
          this.addMessage(currentUserID, correspondentSenderName, conversationId, message, contentType);
        }
    }

    private addMessage(senderId: string, senderName: string, conversationId: string, message: string, contentType: number): Promise<firebase.default.firestore.DocumentReference> {
      return this.afs.collection(`${environment.firebaseConfig.path}/${conversationId}/Messages`).add({
        id: Guid.newGuid(),
        contentType: contentType,
        message: message,
        senderId: senderId,
        senderName: senderName,
        timestamp: this.getUnixEpochInSeconds()
      });
    }

    sendMessageReassigned(message: string, correspondentUserId: string, conversationId: string, createConversation: boolean): void {
      let currentUserID = localStorage.getItem('userId');

      let conversations = this.afs.collection(`${environment.firebaseConfig.path}`);
      if (createConversation) {
        conversations.doc(conversationId).set({
          id: conversationId,
          timestamp: this.getUnixEpochInSeconds(),
          senderId: currentUserID,
          target: correspondentUserId
        }).then(() => {
          return this.addMessageReassigned(currentUserID, conversationId, message);
        }).catch(err => console.error(err));
      } else {
        //this.addMessage(currentUserID, conversationId, message);
      }
  }

  private addMessageReassigned(senderId: string, conversationId: string, message: string): Promise<firebase.default.firestore.DocumentReference> {
    return this.afs.collection(`${environment.firebaseConfig.path}/${conversationId}/Messages`).add({
      id: Guid.newGuid(),
      contentType: 3,
      message: message,
      senderId: senderId,
      timestamp: this.getUnixEpochInSeconds()
    });
  }

    private getUnixEpochInSeconds(): number {
      return Math.floor(Date.now() / 1000);
    }
}

class Guid {
    static newGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}